import { render, staticRenderFns } from "./KnowledgeManageSettings.vue?vue&type=template&id=193ee2b0&scoped=true&"
import script from "./KnowledgeManageSettings.vue?vue&type=script&lang=js&"
export * from "./KnowledgeManageSettings.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeManageSettings.vue?vue&type=style&index=0&id=193ee2b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193ee2b0",
  null
  
)

export default component.exports